import { Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import Moment from 'react-moment';
import DatePicker from "react-datepicker";
import { eventService } from '../../Services/eventService';
import toast from 'react-hot-toast';
import { timeZoneUtil } from '../../Utils/timeZoneUtil';

const EditEventModal = (props) => {
    const [event, setEvent] = useState(props.event ?? {});

    const saveEditEvent = () => {
        if (props.event != null) {
            eventService.updateEvent(event.eventId, event).then(successSave).catch(failureSave);
        } else {
            if(event == null || event.eventDate == null) {
                toast.error("Please select a date for the event");
                return;
            }
            var updatedDate = timeZoneUtil.getDateFromTimestamp(event.eventDate);
            eventService.createEvent({ ...event, eventDate: updatedDate, aoiId: props.aoiId }).then(successSave).catch(failureSave);
        }
    };

    const successSave = (e) => {
        toast.success("Successfully saved the changes");
        props.reload();
        props.setShow(false);
    };

    const failureSave = (e) => {
        console.log(e);
        toast.error("Unable to save the changes");
    };

    return (
        <Modal
            show={() => props.setShow(true)}
            onHide={() => props.setShow(false)}
            backdrop="static"
            keyboard={false}
            dialogClassName=""
            className="member-edit-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <h5>{props.event == null ? <span>Create Event</span> : <span>Edit Event</span>}</h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    {
                        props.event == null ?
                            <>
                                <div className='form-row'>
                                    <label className="form-label" htmlFor="Date">Date From:</label>
                                    <DatePicker
                                        selected={event?.eventDate}
                                        onChange={(date) => setEvent({ ...event, eventDate: date })}
                                        isClearable={true}
                                        className="form-control date"
                                    />
                                </div>
                            </>
                            : <div>Date: <Moment date={event.eventDate} format={"Do MMMM YYYY"} /></div>
                    }
                    <div className='form-row'>Name: <input type="text" className="form-control" value={event?.name} onChange={(e) => setEvent({ ...event, name: e.target.value })} /></div>
                    <div className='form-row'>Is Internal Event     <div><input type="checkbox" checked={event?.isInternal} onChange={(e) => setEvent({ ...event, isInternal: e.target.checked })} /></div> </div>
                    <div className='form-row'>Image Credits <input type="text" className="form-control" value={event?.imageCredits} onChange={(e) => setEvent({ ...event, imageCredits: e.target.value })} /></div>
                    <div className='form-row'>External URL <input type="text" className="form-control" value={event?.externalUrl} onChange={(e) => setEvent({ ...event, externalUrl: e.target.value })} /></div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-text" onClick={() => props.setShow(false)}>CANCEL</button>
                <button type="button" className='btn btn-primary submit-btn' onClick={() => saveEditEvent()}>SAVE</button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditEventModal;